import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FileStorageInjectionToken, FileStorageServiceInterface } from '../../interfaces/file-storage.interface';
import {
    JsonWorkWeekdayModel,
    WorkWeekdayModel,
    WorkWeekdayModelFromJson,
} from '../../models/complex/work-weekday.model';
import { isErrorWithCode } from '../../utilities/is-error-with-code';

const WEEKLY_WORK_MODEL_KEY = 'WorkWeekdayModel';

@Injectable({
    providedIn: 'root',
})
export class WeeklyWorkTimeFileStorageService {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        @Inject(FileStorageInjectionToken) private readonly fileStorage: FileStorageServiceInterface,
    ) {}

    public getWeeklyWorkModel(): Observable<WorkWeekdayModel> {
        return this.fileStorage.loadCompressedData<JsonWorkWeekdayModel>(WEEKLY_WORK_MODEL_KEY).pipe(
            map((jsonWeeklyWorkModel) => new WorkWeekdayModelFromJson(jsonWeeklyWorkModel)),
            catchError((error) => {
                if (isErrorWithCode(error) && error.code === 1) {
                    this.log.debug(`WeeklyWorkTimeFileStorageService: getWeeklyWorkModel: Work time was not found`);
                }
                return of(new WorkWeekdayModel([]));
            }),
        );
    }

    public saveWeeklyWorkModel(weeklyWorkList: WorkWeekdayModel): Observable<WorkWeekdayModel> {
        return this.fileStorage.storeCompressedData(WEEKLY_WORK_MODEL_KEY, weeklyWorkList);
    }
}
